import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import Account from '../Account';
import DashBoard from '../DashBoard';
import Tip from '../Tip';
import UserDetail from '../User/UserDetail';
import AssignableSubscriptionList from '../Subscription/AssignableSubscriptionList';
import MessageList from '../Message/MessageList';

export default () => (
  <Switch>
    <Route exact path="/messages/:type(received)" component={MessageList} />
    <Route path="/account" component={Account} />
    <Route path="/tips" component={Tip} />
    <Route exact path="/users/:userId(\d+)" component={UserDetail} />
    <Route exact path="/subscriptions" component={AssignableSubscriptionList} />
    <Route exact path="/" component={DashBoard} />
    <Redirect to="/" />
  </Switch>
);
